// extracted by mini-css-extract-plugin
export default {"card_body":"CardBody_card_body__BxPRY","title":"CardBody_title__Y466z"};